import { DressingWeight } from '@sg/graphql-schema';

// ─── Modifications ───────────────────────────────────────────────────────────

export const MODIFICATION_INGREDIENT_KINDS = {
  BASES: 'BASES',
  BREAD: 'BREAD',
  DRESSINGS: 'DRESSING',
  PREMIUMS: 'PREMIUM',
  TOPPINGS: 'TOPPING',
};

// ─── Dressings ───────────────────────────────────────────────────────────────

const DRESSING_WEIGHTS: DressingWeight[] = [
  DressingWeight.Light,
  DressingWeight.Medium,
  DressingWeight.Heavy,
];
const DRESSING_WEIGHT_PORTIONS_MAP: Record<DressingWeight, number> = {
  [DressingWeight.Light]: 1,
  [DressingWeight.Medium]: 2,
  [DressingWeight.Heavy]: 3,
};

const DEFAULT_DRESSING_WEIGHT = DressingWeight.Medium;
const DEFAULT_MULTIPLE_DRESSING_WEIGHT = DressingWeight.Light;

export const DRESSINGS = {
  DEFAULT_DRESSING_WEIGHT,
  DEFAULT_MULTIPLE_DRESSING_WEIGHT,

  WEIGHTS: DRESSING_WEIGHTS,
  WEIGHT_PORTIONS_MAP: DRESSING_WEIGHT_PORTIONS_MAP,
};
